import { IconProps } from '@tabler/icons-react';
import { Link, useLocation } from 'react-router-dom';
import { classnames } from '@/libs/utils';

export type NavItemType = {
  icon: React.ComponentType<IconProps>;
  filledIcon: React.ComponentType<IconProps>;
  label: string;
  href: string;
  unseenCount?: number;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  iconContainerClassName?: string;
};

export default function NavItem({ navItem }: { navItem: NavItemType }) {
  const location = useLocation();

  const isActive = location.pathname.startsWith(navItem.href);

  return (
    <div className="!mb-2">
      <Link
        to={navItem.href}
        state={{
          previousPathname: location.pathname
        }}
        onClick={navItem.onClick}
      >
        <li className="group relative flex cursor-pointer flex-col items-center space-y-0.5">
          {navItem.unseenCount && !isActive ? (
            <div
              data-testid="nav-item-unseen-count"
              className="absolute right-1 top-0 flex size-4 items-center justify-center rounded-full bg-deep-orange text-2xs font-semibold text-white"
            >
              {navItem.unseenCount}
            </div>
          ) : null}
          <div
            className={classnames(
              'flex size-10 items-center justify-center rounded-lg',
              {
                'bg-gray-300': isActive,
                'group-hover:bg-slate-200': !isActive
              },
              navItem.iconContainerClassName ?? ''
            )}
          >
            {isActive ? (
              <navItem.filledIcon className="size-[18px] text-black" />
            ) : (
              <navItem.icon className="size-5 text-slate-600 group-hover:bg-slate-200 group-hover:text-black" />
            )}
          </div>
          <span
            className={classnames('text-xs', {
              'text-black': isActive,
              'text-slate-600 group-hover:text-black': !isActive
            })}
          >
            {navItem.label}
          </span>
        </li>
      </Link>
    </div>
  );
}
